import React from 'react';
import { OEmbed } from './';

export const InstagramEmbed = ({ id }) => {
  const params = new URLSearchParams();
  params.append('url', `https://instagr.am/p/${id}/`);
  params.append('access_token', '227370684433724|d64249ee8dcd60ac7ef3e285ad57ccc9');
  params.append('maxwidth', '320');
  params.append('hidecaption', 'true');
  return <OEmbed url={`https://graph.facebook.com/v11.0/instagram_oembed/?${params.toString()}`} />;
};
